export default `
<!-- HTML Example -->
<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.4; width: 100%; max-width: 600px;">
  <tr>
    <td style="padding: 16px 0;">
      <strong>FP Digital Business Solutions GmbH</strong><br />
      Digital Business Solutions<br />
      <br />
      <span style="color: #555;">Adresse:</span> Barbara-McClinktock-Strasse 11, 12489 Berlin<br />
      <span style="color: #555;">Telefon:</span> +49 (0)30 36 44 400<br />
      <span style="color: #555;">E-Mail:</span> <a href="mailto:kontakt@fp-dbs.de" style="color: #0072c6; text-decoration: none;">kontakt@fp-dbs.de</a><br />
      <span style="color: #555;">Web:</span> <a href="https://www.fp-dbs.de" style="color: #0072c6; text-decoration: none;">www.fp-dbs.de</a>
    </td>
  </tr>
  <tr>
    <td style="padding-top: 8px; font-size: 12px; color: #888888;">
      Geschäftsführer: Herr Stephan Vanberg<br />
      Registergericht: Amtsgericht Berlin-Charlottenburg<br />
      Handelsregister: HRB 13886 B<br />
      USt-IdNr.: DE 224 542 346
    </td>
  </tr>
  <tr>
    <td style="padding-top: 16px; font-size: 11px; color: #999999;">
      Diese E-Mail und etwaige Anhänge sind vertraulich und ausschließlich für den/die Adressat:in bestimmt. Wenn Sie nicht der/die beabsichtigte Empfänger:in sind, informieren Sie uns bitte und löschen diese Nachricht.
    </td>
  </tr>
</table>
`
